// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"b7c74694","154":"3147810f","453":"807aabfb","496":"e6cef923","511":"ca598b5e","678":"7fe49cdf","680":"b390191f","763":"b61ded6f"}[chunkId] + ".chunk.js";
};